import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    // padding: '1rem',
  },

  dataSourceRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '1rem',
  },

  item: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '150px',
    flex: '0 0 auto',

    '& h3': {
      color: getRGBA('#0F0F1E', 0.6),
      fontFamily: 'Nunito',
      fontSize: '0.75rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '1.25rem',
      margin: 0,
      padding: 0,
    },

    '& span': {
      color: '#0F0F1E',
      fontFamily: 'Nunito',
      fontSize: '0.75rem',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '1.25rem',
    },

    '& div': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '0.25rem',

      '& p': {
        color: '#0F0F1E',
        fontFamily: 'Nunito',
        fontSize: '0.75rem',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '1.25rem',
        margin: 0,
        padding: 0,
      },
    },
  },

  divider: {
    margin: 0,
    marginLeft: '1.5rem',
    marginRight: '1.5rem',
    height: '2.75rem',
    opacity: 0.25,
    padding: 0,
  },
}))

export { useStyles }